import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';
import {BehaviorSubject, Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {map, tap} from 'rxjs/operators';
import {ApiService} from '../api/api.service';
import {EvaluationRatingScale} from '../models/models.lib';

const { apiUrl } = environment;

export abstract class CasiEvaluationRatingScaleService extends BehaviorSubject<Array<any>>{
  public loading: boolean = false;

  constructor(
    private http: HttpClient,
  ) {
    super([]);
  }

  public query(evaluationId: number): void {
    this.fetch(evaluationId).subscribe((x) => {
      return super.next(x);
    });
  }

  protected fetch(evaluationId: number): Observable<EvaluationRatingScale[]> {
    this.loading = true;

    return this.http.get(encodeURI(`${apiUrl}/evaluation/rating/scale/all/${evaluationId}`))
      .pipe(
        map((response: any, i) => {
          return <EvaluationRatingScale[]>response;
        }),
        map(r => r.map(x => EvaluationRatingScale.create(x))),
        tap(() => (this.loading = false))
      )
  }
}



@Injectable({
  providedIn: 'root'
})
export class EvaluationRatingScaleService  extends CasiEvaluationRatingScaleService  {
  constructor(
    http: HttpClient,
    private apiService: ApiService
  ) {
    super(http)
  }

  get(evaluationId: number) {
    return this.apiService.getHttpCall(`evaluation/rating/scale/all/${evaluationId}`, 'get');
  }

  add(p: any): Promise<any> {
    return this.apiService.postHttpCallAsPromise('evaluation/rating/scale', p, 'add');
  }

  update(id: number, dataItem: any): Promise<any> {
    return this.apiService.putHttpCallAsPromise(`evaluation/rating/scale/${id}`, dataItem , 'update');
  }

  destroy(id: number): Promise<any> {
    return this.apiService.deleteHttpCallAsPromise(`evaluation/rating/scale/${id}` , 'destroy');
  }
}
